import { useState } from "react";

/**
 * Custom hook to validate form data based on field definitions.
 * @param {Array} fields - The array of field definitions (from inquiryFormFields.js).
 * @param {Object} formData - The current form data object.
 */
const useFormValidation = (fields, formData) => {
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    fields.forEach((field) => {
      const { name, required, type, condition } = field;
      const value = formData[name];

      // Skip validation if not required
      if (!required) return;

      // Handle conditional fields (e.g. Flash image)
      if (condition) {
        const { field: dependency, value: expectedValue } = condition;
        if (formData[dependency] !== expectedValue) return;
      }

      // Validate multiple image uploads
      if (type === "uploadcare-multiple") {
        const hasAtLeastOneImage =
          Array.isArray(value) &&
          value.some((image) => image && image.trim() !== "");

        if (!hasAtLeastOneImage) {
          newErrors[name] = "Please upload at least one reference image.";
        }

        return;
      }

      // Validate checkboxes
      if (type === "checkbox") {
        if (!Array.isArray(value) || value.length === 0) {
          newErrors[name] = "Please select at least one option.";
        }
        return;
      }

      if (name === "phoneNumber" && !/^\d{10}$/.test(value || "")) {
        newErrors[name] = "Please enter all 10 digits of your phone number.";
        return;
      }

      // Standard required field check
      if (!value || String(value).trim() === "") {
        newErrors[name] = "This field is required.";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return { errors, validate };
};

export default useFormValidation;
